import React, {useEffect, useState} from 'react';
import {
    ReactComponent as CalendarIcon
} from '../../../../../../../assets/main/groups/main-table/period-calendar/calendar.svg';
import {ReactComponent as InfoSmallerIcon} from '../../../../../../../assets/main/test/info-smaller.svg';

import {ReactComponent as FileIcon} from '../../../../../../../assets/main/groups/form/file.svg';
import {ReactComponent as CloseIcon} from '../../../../../../../assets/header/сlose.svg';
import {useFormik} from "formik";
import './form.css'

import TextArea from "antd/es/input/TextArea";
import {DatePicker, message} from "antd";
import {DatePickerProps} from "antd";
import dayjs from "dayjs";
import {fetchAddLesson} from "features/model/service/add-lesson/fetchAddLesson";
import {useFileUpload} from "common/hook/use-file-upload";
import {useInputWithFocus} from "common/hook/useInputWithFocus";
import {useAppDispatch, useAppSelector} from "common/hook";
import {useNavigate, useParams} from "react-router-dom";
import {clearErrors, setError} from "features/model/slice/addLessonSlice";
import {RangePickerProps} from "antd/es/date-picker";


export const AddLessonForm = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const {isLoading, error, errors, success} = useAppSelector(state => state.addLesson);
    const [isSubmitting, setIsSubmitting] = useState(false);



    const {groupId} = useParams();


    const successMessageError = () => {
        message.error(error);
    };

    const successMessageTrue = () => {
        message.success('Занятие успешно создано');
    };



    const {
        isFilled,
        handleFocus,
        handleBlur
    } = useInputWithFocus([false, false, false, false, false, false, false, false, false, false]);


    const onOk = (value: DatePickerProps['value'] | RangePickerProps['value']) => {
        if(value) {
            dispatch(clearErrors())
        }
        formik.setFieldValue('startTime', value);
    };
    const onOk1 = (value: DatePickerProps['value'] | RangePickerProps['value']) => {
        if(value) {
           dispatch(clearErrors())
        }
        formik.setFieldValue('endTime', value);
    };

    // Блок 1
    const {
        drag: drag1,
        fileNames: fileNames1,
        fileInputRef: fileInputRef1,
        handleFileUpload: handleFileUpload1,
        handleFileRemove: handleFileRemove1,
        handleFileChange: handleFileChange1,
        dragStartHandler: dragStartHandler1,
        dragLeaveHandler: dragLeaveHandler1,
        onDropHandler: onDropHandler1,
        uploadedFiles: uploadedFiles1,
    } = useFileUpload();

    // Блок 2
    const {
        drag: drag2,
        fileNames: fileNames2,
        fileInputRef: fileInputRef2,
        handleFileUpload: handleFileUpload2,
        handleFileRemove: handleFileRemove2,
        handleFileChange: handleFileChange2,
        dragStartHandler: dragStartHandler2,
        dragLeaveHandler: dragLeaveHandler2,
        onDropHandler: onDropHandler2,
        uploadedFiles: uploadedFiles2,
    } = useFileUpload();


    const formik = useFormik({
        initialValues: {
            lessonName: "",
            startTime: "",
            endTime: "",
            lessonDescription: "",
            homeworkEnabled: false,
            published: true,
            homeworkDescription: "",
        },
        onSubmit: (values) => {

        },
    });


    const handleReset = () => {
        formik.resetForm();
        navigate(`/groups/${groupId}`)
    };


    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsSubmitting(true);
        const formData = new FormData();
        formData.append("title", formik.values.lessonName);
        formData.append("description", formik.values.lessonDescription);
        if (groupId !== undefined) {
            formData.append("group_id", groupId.toString());
        }
        formData.append("status", "new");


        formData.append("start_at", dayjs(formik.values.startTime).isValid()
            ? dayjs(formik.values.startTime).format("YYYY-MM-DD HH:mm")
            : ""
        );

        // Проверка и форматирование даты и времени окончания
        const endTimeFormatted = dayjs(formik.values.endTime).isValid()
            ? dayjs(formik.values.endTime).format("YYYY-MM-DD HH:mm")
            : "";

        if (endTimeFormatted) {
            formData.append("finish_at", endTimeFormatted);
        }

        formData.append("homework", formik.values.homeworkDescription);
        formData.append("has_homework", formik.values.homeworkEnabled.toString());
        formData.append("published", formik.values.published.toString());

        if (uploadedFiles1.length > 0) {
            uploadedFiles1.forEach((file) => {
                formData.append(`files[]`, file);
            });
        }

        if (uploadedFiles2.length > 0) {
            uploadedFiles2.forEach((file, index) => {
                formData.append(`homework_files[]`, file);
            });
        }

        try {
            await dispatch(fetchAddLesson(formData));
            setIsSubmitting(false);
        } catch (error) {
            successMessageError();
            setIsSubmitting(false);
        }
    };


    useEffect(() => {
        if (success) {
            dispatch(setError({success: false, error: '', errors: {}}));
            successMessageTrue();
            if (success && groupId) {
                navigate(`/groups/${groupId}`);
            }
        }
    }, [success, dispatch, groupId]);

    const disabledDate: RangePickerProps['disabledDate'] = (current) => {
        return current && current < dayjs().startOf('day');
    };



    const disabledTime = (selectedDate: dayjs.Dayjs | null) => {
        const now = dayjs();

        if (!selectedDate || selectedDate.isBefore(now, 'day')) {
            return {
                disabledHours: () => [],
                disabledMinutes: () => [],
            };
        }

        return {
            disabledHours: () => Array.from({ length: 24 }, (_, i) => i).filter((hour) =>
                selectedDate.isSame(now, 'day') && hour < now.hour()
            ),
            disabledMinutes: () => {
                if (selectedDate.isSame(now, 'hour')) {
                    return Array.from({ length: 60 }, (_, i) => i).filter((minute) => minute < now.minute());
                }
                return [];
            },
        };
    };

        return (
            <div className="create-lesson-box">
                <p className="h4 box-title padding">Занятие</p>

                <form className="form" onSubmit={handleSubmit}>
                    <div className="fields-row" style={{position: "relative"}}>
                        <div
                            className={`field required ${isFilled[0] ? 'filled' : ''} ${errors?.title ? 'error-field' : ''}`}>
                            <label
                                className={`field-name ${formik.values.lessonName ? 'active-label' : ''}`}
                            >
                                Название занятия
                            </label>
                            <div className="inp-box">
                                <input
                                    type="text"
                                    className="form-control has-icon datepicker"
                                    id="lessonName"
                                    name="lessonName"
                                    value={formik.values.lessonName}
                                    onChange={formik.handleChange}
                                    onFocus={() => handleFocus(0)}
                                    onBlur={handleBlur}
                                />
                            </div>
                        </div>
                        {errors?.title && <p className="field-error">{errors?.title}</p>}
                    </div>

                    <div className="fields-row two-cols">
                        <div
                            className={`field has-icon-inp  ${isFilled[1] ? "filled" : ""} ${errors?.start_at ? 'error-field' : ''}`}>
                            <label className={`field-name ${formik.values.startTime ? 'active-label' : ''}`}>Дата и
                                время
                                начала</label>
                            <div className="inp-box">
                                <DatePicker
                                    style={{cursor: 'pointer', caretColor: 'transparent', overflow: 'visible'}}
                                    className="form-control"
                                    placeholder={''}
                                    disabledDate={disabledDate}
                                    disabledTime={disabledTime}
                                    suffixIcon={<span className="icon-date"><CalendarIcon/></span>}
                                    showTime={{format: 'HH:mm'}}
                                    onChange={(value, dateString) => {
                                    }}
                                    onFocus={() => handleFocus(1)}
                                    format="DD-MM-YYYY HH:mm"
                                    onOk={onOk}
                                />
                            </div>
                            {errors?.start_at && <p className="field-error">{errors?.start_at}</p>}
                        </div>
                        <div
                            className={`field has-icon-inp  ${isFilled[2] ? "filled" : ""} ${errors?.finish_at ? 'error-field' : ''}`}>
                            <label className={`field-name ${formik.values.endTime ? 'active-label' : ''}`}>
                                Дата и время окончания</label>
                            <div style={{}} className="inp-box">
                                <DatePicker
                                    style={{cursor: 'pointer', caretColor: 'transparent', overflow: 'visible'}}
                                    className="form-control"
                                    placeholder={''}
                                    disabledDate={disabledDate}
                                    disabledTime={disabledTime}
                                    suffixIcon={<span className="icon-date"><CalendarIcon/></span>}
                                    showTime={{format: 'HH:mm'}}
                                    onFocus={() => handleFocus(2)}
                                    onBlur={handleBlur}
                                    onChange={(value, dateString) => {
                                    }}
                                    format="DD-MM-YYYY HH:mm"
                                    onOk={onOk1}
                                />
                            </div>
                            {errors?.finish_at && <p className="field-error">{errors?.finish_at}</p>}
                        </div>
                    </div>
                    <p className="p-icon info-icon bottom">
                        Укажите время занятия по Минску.
                        <span className="icon">
                          <InfoSmallerIcon/>
                </span>
                    </p>
                    <div className="fields-row">
                        <div className={`field ${isFilled[3] ? 'filled' : ''}`}>
                            <label
                                className={`field-name ${formik.values.lessonDescription ? 'active-label' : ''}`}
                            >Описание занятия</label>
                            <div className="textarea-box">
                                <TextArea
                                    className="form-control"
                                    id="lessonDescription"
                                    name="lessonDescription"
                                    value={formik.values.lessonDescription}
                                    onChange={formik.handleChange}
                                    onFocus={() => handleFocus(3)}
                                    onBlur={handleBlur}
                                    autoSize={{minRows: 3, maxRows: 15}}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="fields-row">
                        <div className="field">
                            {drag1 ?
                                <div
                                    onDragStart={(e) => dragStartHandler1(e)}
                                    onDragLeave={(e) => dragLeaveHandler1(e)}
                                    onDragOver={(e) => dragStartHandler1(e)}
                                    onDrop={(e) => onDropHandler1(e)}
                                    onClick={handleFileUpload1}
                                    className="upload-box upload-box-drop"
                                >
                                    <p>Отпустите файл, чтобы загрузить его</p>
                                </div> :
                                <div className="upload-box">
                                    <div
                                        onDragStart={(e) => dragStartHandler1(e)}
                                        onDragLeave={(e) => dragLeaveHandler1(e)}
                                        onDragOver={(e) => dragStartHandler1(e)}
                                        onDrop={(e) => onDropHandler1(e)}
                                        className="form-button"
                                        onClick={handleFileUpload1}
                                    >
                                        <FileIcon/>
                                        <p
                                            onDragStart={(e) => dragStartHandler1(e)}
                                            onDragLeave={(e) => dragLeaveHandler1(e)}
                                            onDragOver={(e) => dragStartHandler1(e)}
                                            onDrop={(e) => onDropHandler1(e)}
                                        >
                                            Перетащите файл сюда или <a>выберите файл</a>
                                        </p>
                                    </div>

                                    <input
                                        id="fileupload"
                                        type="file"
                                        name="fileupload"
                                        ref={fileInputRef1}
                                        style={{display: "none"}}
                                        onChange={handleFileChange1}
                                        multiple={true}
                                    />
                                </div>
                            }
                            <div className="uploaded-files">
                                <ul className="uploaded-files-list">
                                    {fileNames1.map((fileName, index) => (
                                        <li key={index}>
                                        <span className="js-remove-file" onClick={() => handleFileRemove1(index)}>
                                            <CloseIcon/>
                                        </span>
                                            <div className="file-name">
                                                <span>{fileName}</span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="fields-row">
                        <div className="field">
                            <div className="switch-box">
                                <label className="h4" htmlFor="switch-btn">
                                    Домашнее задание
                                </label>
                                <div className="switch-btn">
                                    <input
                                        id="switch-btn"
                                        type="checkbox"
                                        name="homeworkEnabled"
                                        checked={formik.values.homeworkEnabled}
                                        onChange={formik.handleChange}
                                    />
                                    <label htmlFor="switch-btn" className="tooltip"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    {formik.values.homeworkEnabled && (
                        <>
                            <div className="fields-row">
                                <div className={`field ${isFilled[4] ? 'filled' : ''}`}>
                                    <label
                                        className={`field-name ${formik.values.homeworkDescription ? 'active-label' : ''}`}
                                    >
                                        Описание домашнего задания</label>
                                    <div className="textarea-box">
                                        <TextArea
                                            className="form-control"
                                            id="homeworkDescription"
                                            name="homeworkDescription"
                                            value={formik.values.homeworkDescription}
                                            onChange={formik.handleChange}
                                            onFocus={() => handleFocus(4)}
                                            onBlur={handleBlur}
                                            autoSize={{minRows: 3, maxRows: 15}}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="fields-row">
                                <div className="field">
                                    {drag2 ?
                                        <div
                                            onDragStart={(e) => dragStartHandler2(e)}
                                            onDragLeave={(e) => dragLeaveHandler2(e)}
                                            onDragOver={(e) => dragStartHandler2(e)}
                                            onDrop={(e) => onDropHandler2(e)}
                                            onClick={handleFileUpload2}
                                            className="upload-box upload-box-drop"
                                        >
                                            <p>Отпустите файл, чтобы загрузить его</p>
                                        </div> :
                                        <div className="upload-box">
                                            <div
                                                onDragStart={(e) => dragStartHandler2(e)}
                                                onDragLeave={(e) => dragLeaveHandler2(e)}
                                                onDragOver={(e) => dragStartHandler2(e)}
                                                onDrop={(e) => onDropHandler2(e)}
                                                className="form-button"
                                                onClick={handleFileUpload2}
                                            >
                                                <FileIcon/>
                                                <p
                                                    onDragStart={(e) => dragStartHandler2(e)}
                                                    onDragLeave={(e) => dragLeaveHandler2(e)}
                                                    onDragOver={(e) => dragStartHandler2(e)}
                                                    onDrop={(e) => onDropHandler2(e)}
                                                >
                                                    Перетащите файл сюда или <a>выберите файл</a>
                                                </p>
                                            </div>

                                            <input
                                                id="filehomework"
                                                type="file"
                                                name="filehomework"
                                                ref={fileInputRef2}
                                                style={{display: "none"}}
                                                onChange={handleFileChange2}
                                                multiple={true}
                                            />
                                        </div>
                                    }
                                    <div className="uploaded-files">
                                        <ul className="uploaded-files-list">
                                            {fileNames2.map((fileName, index) => (
                                                <li key={index}>
                                                <span className="js-remove-file"
                                                      onClick={() => handleFileRemove2(index)}>
                                                    <CloseIcon/>
                                                </span>
                                                    <div className="file-name">
                                                        <span>{fileName}</span>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </>

                    )}

                    <div className="btns-box aside-btns">
                        <div className="col sub-col">
                            <div className="switch-box">
                                <label htmlFor="switch-btn2">
                                    Опубликовать занятие и открыть доступ в группе
                                </label>
                                <div className="switch-btn">
                                    <input
                                        id="switch-btn2"
                                        type="checkbox"
                                        name='published'
                                        checked={formik.values.published}
                                        onChange={formik.handleChange}
                                    />
                                    <label
                                        htmlFor="switch-btn2"
                                        className="tooltip">
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="col btns-col">
                            <button type="button" className="btn secondary" onClick={handleReset}>
                                <span>Отменить</span>
                            </button>
                            <button
                                type="submit"
                                className="btn"
                                disabled={isSubmitting || isLoading}
                            >
                                <span>{isSubmitting ? 'Создание...' : 'Создать занятие'}</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        );
    };


